import styled from 'styled-components'
import { em } from 'polished'

import { Text } from 'shared/Typography'

const BG_COLOR = '#262c33'
const ACCENT_COLOR = '#b99eff'
const IMAGE_PATH_DESKTOP = '/static/images/banner-genom/photo.png'
const IMAGE_PATH_TABLET = '/static/images/banner-genom/photo-tablet.png'
const IMAGE_PATH_MOBILE = '/static/images/banner-genom/photo-mobile.png'

export const Root = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  background-color: ${BG_COLOR};
  overflow: hidden;
`

/**
 * Картинка с двойным эффектом:
 * 1) mask-image — чистый овальный clip к прозрачности по краям (нет seam)
 * 2) ::after — видимое затемнение radial-gradient внутри маски (виден vignette)
 *
 * Desktop: справа, 52.89%. Tablet: right-aligned, 80.34%. Mobile: full-width.
 */
export const Photo = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 61.8%;
  background-image: url('${IMAGE_PATH_MOBILE}');
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center bottom;

  ${p => p.theme.mq.upMd} {
    left: auto;
    right: 0;
    width: 80.34%;
    height: 73.13%;
    background-image: url('${IMAGE_PATH_TABLET}');
    background-size: contain;
    background-position: center bottom;
  }

  ${p => p.theme.mq.upLg} {
    left: auto;
    top: 0;
    bottom: 0;
    right: 0;
    width: 52.89%;
    height: 100%;
    background-image: url('${IMAGE_PATH_DESKTOP}');
    background-size: cover;
    background-position: center center;
  }
`

export const Content = styled.div`
  position: relative;
  z-index: 3;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  box-sizing: border-box;
  padding: ${em(46)} ${em(20)} 0;

  ${p => p.theme.mq.upMd} {
    padding: ${em(60)} ${em(20)} 0;
  }

  ${p => p.theme.mq.upLg} {
    padding: ${em(100)} 0 0 ${em(80)};
  }
`

export const Title = styled(Text)`
  color: #fff;
  max-width: 320px;

  & span {
    color: ${ACCENT_COLOR};
  }

  ${p => p.theme.mq.upMd} {
    max-width: 728px;
  }

  ${p => p.theme.mq.upLg} {
    max-width: 455px;
  }
`

export const Description = styled(Text)`
  margin-top: ${em(10)};
  color: #fff;
  max-width: 320px;

  ${p => p.theme.mq.upMd} {
    margin-top: ${em(20)};
    max-width: 355px;
  }

  ${p => p.theme.mq.upLg} {
    max-width: 354px;
  }
`

export const PriceRow = styled.div`
  position: relative;
  z-index: 3;
  display: flex;
  align-items: center;
  gap: ${em(20)};
  padding: ${em(50)} ${em(20)} 0;

  ${p => p.theme.mq.upMd} {
    padding: ${em(120)} ${em(20)} 0;
  }

  ${p => p.theme.mq.upLg} {
    padding: 0;
    position: absolute;
    left: ${em(80)};
    top: ${em(488)};
  }
`

export const Price = styled(Text)`
  color: #fff;
  white-space: nowrap;
`
